function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgColor = function SvgColor(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 515.924 515.924",
    style: {
      enableBackground: "new 0 0 515.924 515.924"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("path", {
    style: {
      fill: "#009CBD"
    },
    d: "M154.53,333.552c0,0.32-0.024,0.64-0.024,0.96c0,72.808,42.36,135.568,103.456,164.444 c-22.972,10.86-48.584,16.96-75.604,16.96c-98.896,0-179.064-81.22-179.064-181.408c0-58.54,27.392-110.568,69.872-143.736 C76.17,250.64,107.85,302.8,154.53,333.552z"
  }), React.createElement("path", {
    style: {
      fill: "#E22B2E"
    },
    d: "M512.63,334.516c0,100.188-80.168,181.408-179.064,181.408c-27.024,0-52.632-6.1-75.604-16.96 c61.096-28.88,103.456-91.636,103.456-164.444c0-3.148-0.08-6.264-0.236-9.372c42.248-32.988,69.548-84.632,69.844-142.776 C480.138,214.712,512.63,270.752,512.63,334.516z"
  }), React.createElement("path", {
    style: {
      fill: "#F57826"
    },
    d: "M154.506,334.516c0-0.32,0.024-0.64,0.024-0.96c28.056,18.484,61.508,29.26,97.464,29.26 c41.116,0,78.964-14.076,109.192-37.672c0.164,3.104,0.24,6.232,0.24,9.372c0,72.808-42.364,135.568-103.456,164.444 C196.866,470.076,154.506,407.32,154.506,334.516z"
  }), React.createElement("path", {
    style: {
      fill: "#00B199"
    },
    d: "M257.962,170.064c-22.972-10.86-48.584-16.96-75.604-16.96c-41.116,0-78.96,14.072-109.192,37.672 c-0.152-3.104-0.236-6.228-0.236-9.368C72.93,81.22,153.094,0,251.994,0c98.904,0,179.068,81.216,179.068,181.408 c0,0.32-0.024,0.636-0.024,0.956c-28.056-18.484-61.508-29.26-97.468-29.26C306.546,153.104,280.934,159.204,257.962,170.064z"
  }), React.createElement("path", {
    style: {
      fill: "#68DBEF"
    },
    d: "M257.962,170.064c-60.832,28.752-103.068,91.088-103.432,163.492 c-46.68-30.752-78.36-82.916-81.364-142.772c30.232-23.6,68.076-37.672,109.192-37.672 C209.378,153.104,234.99,159.204,257.962,170.064z"
  }), React.createElement("path", {
    style: {
      fill: "#FDDF68"
    },
    d: "M361.186,325.14c-3.456-68.8-44.756-127.444-103.224-155.08c22.972-10.86,48.584-16.96,75.604-16.96 c35.96,0,69.416,10.776,97.46,29.26C430.73,240.508,403.43,292.152,361.186,325.14z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M154.53,333.552c0.364-72.4,42.6-134.736,103.432-163.488c58.464,27.636,99.76,86.28,103.224,155.08 c-30.228,23.596-68.076,37.672-109.192,37.672C216.038,362.816,182.574,352.04,154.53,333.552z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color.de76c62c.svg";
export { ForwardRef as ReactComponent };